import React from "react";
import { RefundThankYou } from "../Components";

export const ThankYou = () => {
  return <RefundThankYou />;
};
